var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.currentNavigationList.some((nav,index)=>nav.path===_vm.$route.path))?_c('keep-alive',[_c('router-view',{on:{"hook:activated":_vm.onComponentActivated}})],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }